import utility from 'src/utils/utility'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { 
    AppSpan, Button, CustomContainer, FlexRow, Form, 
    FormGroup, GridContainer, ScreenContainer, ScreenTitle 
} from 'src/style'


const PasswordReset: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {userData}} = useContext(AppInfoContext)
    const [input, setInput] = useState({password: '', confirmPassword: '', code: ''})

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const response = await API.resetPassword({...input, email: userData.email})
        if (response) navigate('/login')
    }
    
    return (
        <ScreenContainer padding='2.5' >
            <GridContainer 
                height='100' hUnit='%'
            >
                <CustomContainer className='preauth-screen-wrapper'>
                    <CustomContainer>
                        <ScreenTitle 
                            color='#000000'
                            textSize='3.2'
                            fontWeight='700'
                        >
                            Reset Password
                        </ScreenTitle>
                        <AppSpan
                            textSize='1.6'
                            color='#4F4F4F'
                        >
                            Lorem ac, arcu, at sed vestibulum, malesuada. Amet, orci ultrices pellentesque aliquam nec. 
                        </AppSpan>
                    </CustomContainer>
                    <Form topMargin='4' onSubmit={handleSubmit}>
                        <FormGroup>
                            <label>New Password</label>
                            <input 
                                placeholder='Enter New Password' 
                                name='password'
                                type='password'
                                value={input.password}
                                autoComplete="off"
                                required
                                onChange={(e) => setInput({...input, password: e.target.value})}
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Confirm Password</label>
                            <input 
                                placeholder='Re-enter Password' 
                                name='confirmPassword'
                                type='password'
                                value={input.confirmPassword}
                                autoComplete="off"
                                required
                                onChange={(e) => setInput({...input, confirmPassword: e.target.value})}
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Code</label>
                            <input 
                                placeholder='Enter OTP' 
                                name='code'
                                type='password'
                                value={input.code}
                                autoComplete="off"
                                required
                                onChange={(e) => setInput({...input, code: e.target.value})}
                            />
                        </FormGroup>
                        <AppSpan
                            textSize='1.6'
                            color='#5627FF'
                            hoverColor='#4F4F4F'
                            fontWeight='700'
                            cursor='pointer'
                            onClick={() => API.sendOtpForPasswordReset(userData.email)}
                        >
                            Resend Otp?
                        </AppSpan>
                        
                        <FlexRow 
                            justifyContent='flex-end' topMargin='4'
                            gap='1.5'
                        >
                            <Button 
                                width='50' 
                                sizeUnit='%'
                                bgColor='#ffffff' 
                                color='#5627FF'
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </Button>
                            <Button 
                                width='50' 
                                sizeUnit='%'
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                            >
                                Reset Password
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </GridContainer>
        </ScreenContainer>
    )
}

export default utility.routeData('/forgot-password/password-reset', 'Password Reset', <PasswordReset/>)